import { render, staticRenderFns } from "./SetupFooter.vue?vue&type=template&id=356f5928&scoped=true"
import script from "./SetupFooter.vue?vue&type=script&lang=js"
export * from "./SetupFooter.vue?vue&type=script&lang=js"
import style0 from "./SetupFooter.vue?vue&type=style&index=0&id=356f5928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f5928",
  null
  
)

export default component.exports